import aifadian_line_black from "@/assets/mainImage/aifadian_line_black.png"
import bilibili_black from "@/assets/mainImage/bilibili_black.png"
import wx_chat_black from "@/assets/mainImage/wx_chat_black.png"
import aifadian_line_active from "@/assets/mainImage/aifadian_line_active.png"
import bilibili_active from "@/assets/mainImage/bilibili_active.png"
import wx_chat_active from "@/assets/mainImage/wx_chat_active.png"
import WeChatCode from "@/assets/mainImage/WeChatCode.jpg"
import scrollTop from "@/assets/mainImage/scrollTop.png"
import scrollTopActive from "@/assets/mainImage/scrollTopActive.png"

import { jumpData, } from "@/common/commonData.js"
import { method, } from "@/common/common.js"

export default {
    data() {
        return {
            method,
            jumpData,
            aifadian_line_black,
            bilibili_black,
            wx_chat_black,
            aifadian_line_active,
            bilibili_active,
            wx_chat_active,
            scrollTop,
            scrollTopActive,
            WeChatCode,
            dialogVisible: false,
            showToTop: false,
        }
    },
    methods: {
        openWxChat() {
            this.dialogVisible = true;
        },
        toTop() {
            method.scrollToTop();
        },
        handleScroll_sideMenu() {
            if (window.scrollY >= 500) {
                this.showToTop = true;
            } else {
                this.showToTop = false;
            }
        }
    },
    mounted() {
        this.handleScroll_sideMenu();
        window.addEventListener('scroll', this.handleScroll_sideMenu);
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.handleScroll_sideMenu);
    }
}